import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AccountDeactivated: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) return null;

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If not deactivated, redirect to home
  if (user.account_status !== "DEACTIVATED") {
    return <Navigate to="/" replace />;
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 12,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{ padding: 4, width: "100%", textAlign: "center" }}
        >
          <Typography variant="h5" color="error" gutterBottom>
            Account Deactivated
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            Your account has been deactivated by your organization
            administrator.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please contact your organization administrator or Alpha Affinity
            support at{" "}
            <a
              href="mailto:support@alpha-affinity.com"
              style={{ color: "#1976d2", textDecoration: "none" }}
            >
              support@alpha-affinity.com
            </a>{" "}
            for assistance.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccountDeactivated;
